<template>
  <b-alert
    v-if="activeFilter && activeFilter !== 'all'"
    show
    variant="info"
    class="mt-3 mb-3"
  >
    <div class="d-flex align-items-center justify-content-between">
      <span class="d-flex align-items-center">
        <feather-icon
          icon="FilterIcon"
          size="18"
          class="mr-1"
        />
        <strong>فیلتر فعال:</strong>
        <span class="mr-2">{{ filterLabel }}</span>
      </span>
      <b-button
        size="sm"
        variant="outline-light"
        @click="clearFilter"
      >
        <feather-icon
          icon="XIcon"
          size="16"
          class="mr-1"
        />
        حذف فیلتر
      </b-button>
    </div>
  </b-alert>
</template>

<script>
import { BAlert, BButton } from 'bootstrap-vue'
import { getFilterLabel } from '@/utils/deviceFilters'

export default {
  name: 'DeviceFilterBadge',
  components: {
    BAlert,
    BButton,
  },
  props: {
    activeFilter: {
      type: String,
      default: null,
    },
  },
  computed: {
    filterLabel() {
      return getFilterLabel(this.activeFilter)
    },
  },
  methods: {
    clearFilter() {
      this.$emit('clear-filter')
    },
  },
}
</script>

<style scoped>
.b-alert {
  border-radius: 8px;
}
</style>